<template>
  <div id="qqqun">
    <!--加群弹窗-->
    <div class="video"></div>
    <div class="qq">
      <h3>请加入学员QQ群</h3>
      <p>
        QQ群号：<b>929753461</b>
      </p>
      <div class="sub">
        <a href="">申请加入</a>
        <a href="">不再提示</a>
      </div>
      <a class="close" href="">&times;</a>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'QQqun'
}
</script>

<style scoped lang="stylus">
  #qqqun
    .video
      width: 7.5rem
      height: 4.4rem
      background: url(../../../../assets/img/liveplay_bg_video.png) no-repeat center
      -webkit-background-size: 100%
      background-size: 100%
      margin: 0 auto
    .qq
      position: fixed
      top: 50%
      left: 50%
      z-index: 100
      width: 5.9rem
      height: 3.6rem
      background-color: #fff
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      h3
        margin: .62rem 0 .26rem
        font-size: .36rem
        color: #333
        text-align: center
      p
        padding: 0
        margin: 0 auto
        font-size: .32rem
        color: #666
        text-align: center
        b
          color: #FF7052
          font-weight: 500
      .sub
        display: flex
        justify-content: space-between
        width: 4.38rem
        height: .68rem
        margin: .42rem auto
        a
          display: inline-block
          width: 2rem
          height: .68rem
          line-height: .64rem
          border: .02rem solid #FF7052
          color: #FF7052
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
          &:first-child
            background-color: #FF7052
            color: #fff
      a.close
        position: absolute
        top: .2rem
        right: .2rem
        display: block
        width: .3rem
        height: .3rem
        line-height: .24rem
        font-size: .4rem
        text-align: center
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 50
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/share/popup/class/QQqun.vue